import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/github-runner/_work/livekit-meet/livekit-meet/node_modules/next/dist/client/app-dir/link.js");
